<template>
    <div style="height: 100%">
        <!-- 双 Tab：巡检记录 / 实例配置 -->
        <el-tabs v-model="activeTab" type="card" @tab-click="onTabChange" style="height:100%; display:flex; flex-direction:column;">
            <!-- ============ Tab1：巡检记录 ============ -->
            <el-tab-pane label="巡检记录" name="record">
                <!-- 顶部：过滤条件 + 操作按钮 -->
                <div style="display: flex; width: 100%">
                    <div style="width: 90%; height: 40px">
                        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                            <el-input v-model="formDatas.instanceName" style="width: 160px;" size="mini"
                                placeholder="实例名" clearable @change="partserch"></el-input>
                            <el-select size="mini" v-model="formDatas.scope" clearable @change="partserch"
                                placeholder="范围" style="width: 130px; margin-left: 6px;">
                                <el-option label="实例级" value="INSTANCE" key="INSTANCE"></el-option>
                                <el-option label="库级" value="DATABASE" key="DATABASE"></el-option>
                            </el-select>
                            <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                                style="margin-left: 6px">搜索</el-button>
                            <el-button type="primary" size="mini" icon="el-icon-video-play" :loading="runLoading"
                                @click="runPatrol" style="margin-left: 6px">执行巡检</el-button>
                            <el-button type="info" size="mini" icon="el-icon-refresh" @click="getList">刷新</el-button>
                        </el-row>
                    </div>
                </div>
                <div class="tablemain">
                    <div class="tablecss">
                        <div style="width: 100%">
                            <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                                :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                                :cell-style-option="cellStyleOption" row-key-field-name="sprId" style="width: 100%" />
                            <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                        </div>
                        <div class="table-pagination">
                            <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                                :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320]"
                                @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                        </div>
                    </div>
                </div>
            </el-tab-pane>

            <!-- ============ Tab2：实例配置 ============ -->
            <el-tab-pane label="实例配置" name="instance">
                <div style="display: flex; width: 100%">
                    <div style="width: 90%; height: 40px">
                        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                            <el-button type="info" size="mini" icon="el-icon-refresh" @click="getInstanceList">刷新</el-button>
                        </el-row>
                    </div>
                    <div style="width: 10%; height: 40px">
                        <el-row style="margin: 10px; width: 95%; display: flex; flex-direction: row-reverse;">
                            <el-button type="success" size="mini" style="margin-right: 20px"
                                @click="openInstanceForm(false)">新增实例</el-button>
                        </el-row>
                    </div>
                </div>
                <div class="tablemain">
                    <div class="tablecss">
                        <div style="width: 100%">
                            <ve-table v-if="instanceData" :columns="instanceColumns" :table-data="instanceData"
                                :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                                :cell-style-option="cellStyleOption" row-key-field-name="spiId" style="width: 100%" />
                            <div v-show="instanceData.length == 0" class="empty-data">暂无数据</div>
                        </div>
                        <div class="table-pagination">
                            <ve-pagination :total="instanceTotal" :page-index="instForm.currentPage"
                                :page-size="instForm.pageSize" :page-size-option="[10, 20, 40, 80, 160]"
                                @on-page-number-change="instPageNumberChange" @on-page-size-change="instPageSizeChange" />
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>

        <!-- ============ 巡检详情 Dialog（保留：概览 + 摘要 + 折叠面板） ============ -->
        <el-dialog :title="'巡检详情 #' + (detail.record && detail.record.sprId || '')" :visible.sync="detailVisible"
            width="80%" top="6vh" :close-on-click-modal="false">
            <div v-if="detail.record" style="max-height: 70vh; overflow-y: auto; padding: 0 10px;">
                <!-- 概览卡片 -->
                <el-row :gutter="15" style="margin-bottom: 10px;">
                    <el-col :span="6">
                        <div class="ov-card">
                            <div class="ov-label">健康分</div>
                            <div class="ov-value" :style="{ color: scoreColor(detail.record.healthScore) }">
                                {{ detail.record.healthScore == null ? '-' : detail.record.healthScore }}
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="ov-card">
                            <div class="ov-label">总体等级</div>
                            <div class="ov-value">
                                <el-tag :type="levelTagType(detail.record.overallLevel)" size="medium">
                                    {{ detail.record.overallLevel || '-' }}
                                </el-tag>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="ov-card">
                            <div class="ov-label">实例 / 库</div>
                            <div class="ov-value text" :title="(detail.record.instanceName || '-') + ' / ' + (detail.record.databaseName || '-')">
                                {{ detail.record.instanceName || '-' }}
                                <span v-if="detail.record.scope == 'DATABASE'" style="color:#909399"> / {{ detail.record.databaseName }}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="ov-card">
                            <div class="ov-label">主机名</div>
                            <div class="ov-value text" :title="detail.record.hostname">{{ detail.record.hostname || '-' }}</div>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="15" style="margin-bottom: 10px;">
                    <el-col :span="6">
                        <div class="ov-card">
                            <div class="ov-label">巡检时间</div>
                            <div class="ov-value text">{{ detail.record.createtime || '-' }}</div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="ov-card">
                            <div class="ov-label">巡检耗时</div>
                            <div class="ov-value text">{{ formatCost(detail.record.costMs) }}</div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="ov-card">
                            <div class="ov-label">结果统计</div>
                            <div class="ov-value" style="font-size: 13px;">
                                <el-tag type="success" size="mini">正常 {{ detail.record.okCount || 0 }}</el-tag>
                                <el-tag type="info" size="mini" style="margin-left:4px">信息 {{ detail.record.infoCount || 0 }}</el-tag>
                                <el-tag type="warning" size="mini" style="margin-left:4px">警告 {{ detail.record.warnCount || 0 }}</el-tag>
                                <el-tag type="danger" size="mini" style="margin-left:4px">严重 {{ detail.record.criticalCount || 0 }}</el-tag>
                            </div>
                        </div>
                    </el-col>
                </el-row>

                <!-- 摘要区：精简版概览，便于一键复制贴给 AI 分析 -->
                <div v-if="detail.summary" class="summary-block">
                    <div class="summary-head">
                        <span class="summary-title">
                            巡检摘要
                            <span class="summary-sub">问题 {{ detail.summary.problemCount || 0 }}
                                （警告 {{ detail.summary.warnCount || 0 }} / 严重 {{ detail.summary.criticalCount || 0 }}）
                            </span>
                        </span>
                        <el-button type="primary" size="mini" plain icon="el-icon-document-copy"
                            @click="copySummary">复制摘要</el-button>
                    </div>
                    <div v-if="detail.summary.problems && detail.summary.problems.length" class="summary-section">
                        <div class="section-label">问题列表</div>
                        <ul class="summary-list">
                            <li v-for="(p, i) in detail.summary.problems" :key="'p'+i">{{ p }}</li>
                        </ul>
                    </div>
                    <div v-if="detail.summary.topIssues && detail.summary.topIssues.length" class="summary-section">
                        <div class="section-label">关键提示</div>
                        <ul class="summary-list">
                            <li v-for="(t, i) in detail.summary.topIssues" :key="'t'+i">{{ t }}</li>
                        </ul>
                    </div>
                    <div v-if="detail.summary.suggestions && detail.summary.suggestions.length" class="summary-section">
                        <div class="section-label">处置建议</div>
                        <ul class="summary-list">
                            <li v-for="(s, i) in detail.summary.suggestions" :key="'s'+i">{{ s }}</li>
                        </ul>
                    </div>
                </div>

                <!-- 检查项明细：按 severity 分组 -->
                <p style="width: 100%;text-align: center;margin: 10px 0;">检查项明细（共 {{ (detail.results || []).length }} 项）</p>
                <el-collapse v-model="activeGroups">
                    <el-collapse-item v-for="g in groupedResults" :key="g.severity" :name="g.severity">
                        <template slot="title">
                            <el-tag :type="levelTagType(g.severity)" size="small">{{ g.severity }}</el-tag>
                            <span style="margin-left: 8px;">{{ severityLabel(g.severity) }}（{{ g.items.length }} 项）</span>
                        </template>
                        <div v-for="(item, idx) in g.items" :key="item.sprResultId || idx" class="check-item">
                            <div class="check-title">
                                <el-tag :type="levelTagType(item.severity)" size="mini">{{ item.severity }}</el-tag>
                                <span style="margin-left: 6px; font-weight: 600;">{{ item.checkName }}</span>
                            </div>
                            <div v-if="item.metrics && Object.keys(item.metrics).length" class="metrics-wrap">
                                <span v-for="(v, k) in item.metrics" :key="k" class="metrics-item">
                                    <span class="metrics-k">{{ k }}</span>
                                    <span class="metrics-v">{{ v }}</span>
                                </span>
                            </div>
                            <div v-if="item.details && item.details.length" style="margin-top:6px;">
                                <el-alert v-for="(d, i) in item.details" :key="i" :title="d" :type="alertType(item.severity)"
                                    :closable="false" show-icon style="margin-bottom: 4px;" />
                            </div>
                            <ve-table v-if="item.tableHeaders && item.tableHeaders.length && item.tableRows && item.tableRows.length"
                                :columns="buildTableColumns(item.tableHeaders)" :table-data="item.tableRows"
                                :max-height="260" :border-x="true" :border-y="true" :scrollWidth="10"
                                :cell-style-option="cellStyleOption" style="width: 100%; margin-top: 6px;" />
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="detailVisible = false">关 闭</el-button>
            </span>
        </el-dialog>

        <!-- ============ 执行巡检结果 Dialog（总览 + 各实例列表） ============ -->
        <el-dialog title="巡检执行结果" :visible.sync="runResultVisible" width="70%" top="8vh" :close-on-click-modal="false">
            <div v-if="runResult">
                <!-- 总览卡片 -->
                <el-row :gutter="15" style="margin-bottom: 15px;">
                    <el-col :span="6">
                        <div class="ov-card">
                            <div class="ov-label">实例总数</div>
                            <div class="ov-value">{{ runResult.instanceCount || 0 }}</div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="ov-card">
                            <div class="ov-label">成功</div>
                            <div class="ov-value" style="color:#67C23A">{{ runResult.successCount || 0 }}</div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="ov-card">
                            <div class="ov-label">失败</div>
                            <div class="ov-value" style="color:#F56C6C">{{ runResult.failCount || 0 }}</div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="ov-card">
                            <div class="ov-label">总耗时</div>
                            <div class="ov-value text">{{ formatCost(runResult.totalCostMs) }}</div>
                        </div>
                    </el-col>
                </el-row>
                <!-- 各实例结果列表：点击可查看该实例某次详情 -->
                <p style="width: 100%;text-align: center;margin: 10px 0;">各实例结果（点击查看详情）</p>
                <ve-table v-if="runResult.instances" :columns="runInstanceColumns" :table-data="runResult.instances"
                    :max-height="360" :border-x="true" :border-y="true" :scrollWidth="10"
                    :cell-style-option="cellStyleOption" row-key-field-name="sprId" style="width: 100%" />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="runResultVisible = false">关 闭</el-button>
            </span>
        </el-dialog>

        <!-- ============ 实例配置 新增/编辑 抽屉 ============ -->
        <el-drawer :wrapperClosable="false" :title="instEdit ? '编辑实例' : '新增实例'" :before-close="closeInstanceForm"
            :visible.sync="instDialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
            <div class="demo-drawer__content" style="height: 90%;">
                <el-form ref="instFormRef" :model="instFormData" :rules="instRules" label-position="top" style="height:100%">
                    <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="实例名称" prop="instanceName">
                            <el-input v-model="instFormData.instanceName" style="width: 80%;" placeholder="如：主服务器"></el-input>
                        </el-form-item>
                        <el-form-item label="主机地址" prop="host">
                            <el-input v-model="instFormData.host" style="width: 80%;" placeholder="如：127.0.0.1"></el-input>
                        </el-form-item>
                        <el-form-item label="端口" prop="port">
                            <el-input v-model="instFormData.port" type="number" style="width: 80%;" placeholder="默认 3306"></el-input>
                        </el-form-item>
                        <el-form-item label="账号" prop="username">
                            <el-input v-model="instFormData.username" style="width: 80%;" placeholder="巡检账号"></el-input>
                        </el-form-item>
                        <el-form-item :label="instEdit ? '密码（留空不修改）' : '密码'" prop="password">
                            <el-input v-model="instFormData.password" show-password style="width: 80%;" placeholder="密码"></el-input>
                        </el-form-item>
                        <el-form-item label="要巡检的库（逗号分隔，空=不巡库）" prop="databases">
                            <el-input v-model="instFormData.databases" style="width: 80%;" placeholder="如：db1,db2"></el-input>
                        </el-form-item>
                        <el-form-item label="是否启用" prop="enabled">
                            <el-radio-group v-model="instFormData.enabled">
                                <el-radio :label="1">启用</el-radio>
                                <el-radio :label="0">禁用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="排序号（小的先巡检）" prop="sort">
                            <el-input v-model="instFormData.sort" type="number" style="width: 80%;" placeholder="如：1"></el-input>
                        </el-form-item>
                        <el-form-item label="备注" prop="remark">
                            <el-input v-model="instFormData.remark" type="textarea" :rows="2" style="width: 80%;" placeholder="备注"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="demo-drawer__footer" style="margin-top: 10px;">
                <!-- 测试连接：用当前表单内容发起，不保存 -->
                <el-button :loading="testLoading" @click="testConnection" style="margin-left: 5%;">测试连接</el-button>
                <el-button @click="closeInstanceForm()" style="margin-left: 18%;">取 消</el-button>
                <el-button type="primary" @click="submitInstance" style="margin-left: 15%;">确 定</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
// 数据库巡检页面（多实例版）：巡检记录 + 实例配置 两个 Tab
import {
    runPatrol, getPatrolList, getPatrolDetail, deletePatrol,
    getPatrolInstanceList, addPatrolInstance, updatePatrolInstance,
    deletePatrolInstance, testPatrolInstance
} from "../../api/api";

// 严重等级展示顺序与中文标签
const SEVERITY_ORDER = ['CRITICAL', 'WARN', 'INFO', 'OK'];
const SEVERITY_LABEL = { CRITICAL: '严重', WARN: '警告', INFO: '信息', OK: '正常' };

export default {
    name: "databasePatrol",
    data() {
        return {
            activeTab: 'record',          // 当前 Tab：record / instance
            // —— 巡检记录 ——
            runLoading: false,
            detailVisible: false,
            detail: { record: null, results: [], summary: null },
            activeGroups: ['CRITICAL', 'WARN'],
            tableData: [],
            totalCount: 0,
            formDatas: {
                currentPage: 1,
                pageSize: 20,
                instanceName: '',          // 列表过滤：实例名
                scope: '',                 // 列表过滤：范围 INSTANCE/DATABASE
            },
            // run 接口返回的多实例聚合结果
            runResultVisible: false,
            runResult: null,
            // —— 实例配置 ——
            instanceData: [],
            instanceTotal: 0,
            instForm: { currentPage: 1, pageSize: 20 },
            instDialog: false,
            instEdit: false,
            testLoading: false,
            instFormData: this.emptyInstForm(),
            instRules: {
                instanceName: [{ required: true, message: '请输入实例名称', trigger: 'blur' }],
                host: [{ required: true, message: '请输入主机地址', trigger: 'blur' }],
                username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
            },
            // —— 公共 ——
            windheight: "",
            tableHight: 520,
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) return "table-header-cell-class";
                },
            },
            // 巡检记录列表列
            columns: [
                { field: "", key: "a", title: "序号", width: 60, align: "center", fixed: 'left',
                    renderBodyCell: ({ rowIndex }, h) => ++rowIndex },
                { field: "createtime", key: "createtime", title: "巡检时间", width: 160, align: "center", fixed: 'left' },
                {
                    field: "healthScore", key: "healthScore", title: "健康分", width: 90, align: "center",
                    renderBodyCell: ({ row }, h) => {
                        const s = row.healthScore;
                        if (s == null) return <span>-</span>;
                        const color = s >= 90 ? '#67C23A' : (s >= 60 ? '#E6A23C' : '#F56C6C');
                        return <span style={{ color, fontWeight: '600', fontSize: '14px' }}>{s}</span>;
                    },
                },
                {
                    field: "overallLevel", key: "overallLevel", title: "总体等级", width: 100, align: "center",
                    renderBodyCell: ({ row }, h) => row.overallLevel
                        ? <el-tag type={this.levelTagType(row.overallLevel)} size="mini">{row.overallLevel}</el-tag>
                        : <span>-</span>,
                },
                // 新增列：实例名 / 范围 / 库名
                { field: "instanceName", key: "instanceName", title: "实例名", width: 130, align: "left" },
                {
                    field: "scope", key: "scope", title: "范围", width: 80, align: "center",
                    renderBodyCell: ({ row }, h) => row.scope == 'DATABASE'
                        ? <el-tag type="warning" size="mini">库级</el-tag>
                        : <el-tag type="info" size="mini">实例级</el-tag>,
                },
                { field: "databaseName", key: "databaseName", title: "库名", width: 120, align: "left",
                    renderBodyCell: ({ row }, h) => <span>{row.databaseName || '-'}</span> },
                { field: "hostname", key: "hostname", title: "主机名", width: 130, align: "left" },
                {
                    field: "costMs", key: "costMs", title: "耗时", width: 110, align: "center",
                    renderBodyCell: ({ row }, h) => <span>{this.formatCost(row.costMs)}</span>,
                },
                {
                    field: "", key: "counts", title: "结果统计", width: 280, align: "center",
                    renderBodyCell: ({ row }, h) => (
                        <span>
                            <el-tag type="success" size="mini">正常 {row.okCount || 0}</el-tag>
                            <el-tag type="info" size="mini" style="margin-left:3px">信息 {row.infoCount || 0}</el-tag>
                            <el-tag type="warning" size="mini" style="margin-left:3px">警告 {row.warnCount || 0}</el-tag>
                            <el-tag type="danger" size="mini" style="margin-left:3px">严重 {row.criticalCount || 0}</el-tag>
                        </span>
                    ),
                },
                {
                    field: "", key: "op", title: "操作", width: 130, align: "center", fixed: 'right',
                    renderBodyCell: ({ row }, h) => (
                        <span>
                            <el-button size="mini" type="text" on-click={() => this.openDetail(row.sprId)}>详情</el-button>
                            <el-button size="mini" type="text" style="color:red" on-click={() => this.handleDelete(row)}>删除</el-button>
                        </span>
                    ),
                },
            ],
            // run 结果里"各实例"列表列：每行是一条 PatrolDetailVO.record
            runInstanceColumns: [
                { field: "instanceName", key: "instanceName", title: "实例", width: 130, align: "left",
                    renderBodyCell: ({ row }, h) => <span>{(row.record && row.record.instanceName) || '-'}</span> },
                { field: "scope", key: "scope", title: "范围", width: 90, align: "center",
                    renderBodyCell: ({ row }, h) => {
                        const s = row.record && row.record.scope;
                        return s == 'DATABASE'
                            ? <el-tag type="warning" size="mini">库级 {row.record.databaseName}</el-tag>
                            : <el-tag type="info" size="mini">实例级</el-tag>;
                    } },
                {
                    field: "healthScore", key: "healthScore", title: "健康分", width: 90, align: "center",
                    renderBodyCell: ({ row }, h) => {
                        const s = row.record && row.record.healthScore;
                        if (s == null) return <span>-</span>;
                        const color = s >= 90 ? '#67C23A' : (s >= 60 ? '#E6A23C' : '#F56C6C');
                        return <span style={{ color, fontWeight: '600' }}>{s}</span>;
                    },
                },
                {
                    field: "overallLevel", key: "overallLevel", title: "等级", width: 90, align: "center",
                    renderBodyCell: ({ row }, h) => {
                        const l = row.record && row.record.overallLevel;
                        return l ? <el-tag type={this.levelTagType(l)} size="mini">{l}</el-tag> : <span>-</span>;
                    },
                },
                {
                    field: "costMs", key: "costMs", title: "耗时", width: 110, align: "center",
                    renderBodyCell: ({ row }, h) => <span>{this.formatCost(row.record && row.record.costMs)}</span>,
                },
                {
                    field: "", key: "counts", title: "结果统计", width: 260, align: "center",
                    renderBodyCell: ({ row }, h) => {
                        const r = row.record || {};
                        return (
                            <span>
                                <el-tag type="success" size="mini">正常 {r.okCount || 0}</el-tag>
                                <el-tag type="warning" size="mini" style="margin-left:3px">警告 {r.warnCount || 0}</el-tag>
                                <el-tag type="danger" size="mini" style="margin-left:3px">严重 {r.criticalCount || 0}</el-tag>
                            </span>
                        );
                    },
                },
                {
                    field: "", key: "op", title: "操作", width: 90, align: "center", fixed: 'right',
                    renderBodyCell: ({ row }, h) => (
                        <el-button size="mini" type="text" on-click={() => this.viewRunInstanceDetail(row)}>详情</el-button>
                    ),
                },
            ],
            // 实例配置列表列
            instanceColumns: [
                { field: "", key: "a", title: "序号", width: 60, align: "center",
                    renderBodyCell: ({ rowIndex }, h) => ++rowIndex },
                { field: "instanceName", key: "instanceName", title: "实例名称", width: 140, align: "left" },
                { field: "host", key: "host", title: "主机地址", width: 140, align: "left",
                    renderBodyCell: ({ row }, h) => <span>{row.host}:{row.port || 3306}</span> },
                { field: "username", key: "username", title: "账号", width: 110, align: "left" },
                { field: "databasesList", key: "databasesList", title: "巡检库", width: 180, align: "left",
                    renderBodyCell: ({ row }, h) => <span>{row.databasesList || '（不巡库）'}</span> },
                {
                    field: "enabled", key: "enabled", title: "启用", width: 80, align: "center",
                    renderBodyCell: ({ row }, h) => row.enabled == 1
                        ? <el-tag type="success" size="mini">启用</el-tag>
                        : <el-tag type="info" size="mini">禁用</el-tag>,
                },
                { field: "sort", key: "sort", title: "排序", width: 70, align: "center" },
                { field: "remark", key: "remark", title: "备注", align: "left",
                    renderBodyCell: ({ row }, h) => <span>{row.remark || '-'}</span> },
                {
                    field: "", key: "op", title: "操作", width: 130, align: "center", fixed: 'right',
                    renderBodyCell: ({ row }, h) => (
                        <span>
                            <el-button size="mini" type="text" on-click={() => this.openInstanceForm(true, row)}>编辑</el-button>
                            <el-button size="mini" type="text" style="color:red" on-click={() => this.deleteInstance(row)}>删除</el-button>
                        </span>
                    ),
                },
            ],
        };
    },
    computed: {
        // 详情 results 按 severity 分组并排序，空组不展示
        groupedResults() {
            const groups = {};
            (this.detail.results || []).forEach(item => {
                const key = item.severity || 'INFO';
                if (!groups[key]) groups[key] = [];
                groups[key].push(item);
            });
            return SEVERITY_ORDER
                .filter(s => groups[s] && groups[s].length)
                .map(s => ({ severity: s, items: groups[s] }));
        },
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
        this.getList();
    },
    deactivated() {
        this.watchFlag = false;
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) this.tableHight = val - 200 - val * 0.04;
            });
        },
    },
    created() {
        this.windheight = this.$store.state.windheight;
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    methods: {
        // ===== 公用工具 =====
        levelTagType(level) {
            return { OK: 'success', INFO: 'info', WARN: 'warning', CRITICAL: 'danger' }[level] || 'info';
        },
        alertType(level) {
            return { OK: 'info', INFO: 'info', WARN: 'warning', CRITICAL: 'error' }[level] || 'info';
        },
        severityLabel(s) {
            return SEVERITY_LABEL[s] || s;
        },
        scoreColor(s) {
            if (s == null) return '#909399';
            return s >= 90 ? '#67C23A' : (s >= 60 ? '#E6A23C' : '#F56C6C');
        },
        formatCost(ms) {
            if (ms == null) return '-';
            if (ms < 1000) return ms + 'ms';
            return Math.floor(ms / 1000) + 's ' + (ms % 1000) + 'ms';
        },
        buildTableColumns(headers) {
            return (headers || []).map((h, i) => ({
                field: h, key: 'c' + i, title: h, align: "center", width: 120,
            }));
        },
        onTabChange(tab) {
            // 切到实例配置 Tab 时懒加载列表
            if (tab.name === 'instance' && this.instanceData.length === 0) {
                this.getInstanceList();
            }
        },

        // ===== 巡检记录 =====
        getList() {
            getPatrolList(this.formDatas).then(res => {
                this.tableData = res.data || [];
                this.totalCount = res.total || 0;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.getList();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.getList();
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.formDatas.currentPage = 1;
            this.getList();
        },
        // 执行巡检：返回多实例聚合结果，弹总览 + 各实例列表
        runPatrol() {
            this.runLoading = true;
            runPatrol().then(res => {
                if (res.data) {
                    this.$message({ type: "success", message: "巡检完成" });
                    this.runResult = res.data;
                    this.runResultVisible = true;
                    this.getList();
                }
            }).finally(() => {
                this.runLoading = false;
            });
        },
        openDetail(sprId) {
            getPatrolDetail({ sprId }).then(res => {
                if (res.data) {
                    this.detail = res.data;
                    this.activeGroups = ['CRITICAL', 'WARN'];
                    this.detailVisible = true;
                }
            });
        },
        // 查看 run 结果里某个实例/库的详情（PatrolDetailVO 自带 record+summary+results）
        viewRunInstanceDetail(instanceDetail) {
            this.detail = instanceDetail;
            this.activeGroups = ['CRITICAL', 'WARN'];
            this.runResultVisible = false;
            this.detailVisible = true;
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除该巡检记录, 是否继续?", "提示", {
                confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
            }).then(() => {
                deletePatrol({ sprId: row.sprId }).then(res => {
                    if (res.data) {
                        this.$message({ type: "success", message: "删除成功!" });
                        this.getList();
                    }
                });
            }).catch(() => { this.$message({ type: "info", message: "已取消" }); });
        },
        // 复制摘要为纯文本（优先 clipboard，降级 execCommand）
        async copySummary() {
            const text = this.buildSummaryText();
            try {
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(text);
                } else {
                    const ta = document.createElement('textarea');
                    ta.value = text;
                    ta.style.position = 'fixed';
                    ta.style.opacity = '0';
                    document.body.appendChild(ta);
                    ta.select();
                    document.execCommand('copy');
                    document.body.removeChild(ta);
                }
                this.$message({ type: "success", message: "摘要已复制" });
            } catch (e) {
                this.$message({ type: "error", message: "复制失败，请手动选择文本复制" });
            }
        },
        buildSummaryText() {
            const s = this.detail.summary || {};
            const lines = [];
            lines.push('【MySQL 巡检摘要】');
            lines.push('实例：' + (this.detail.record && this.detail.record.instanceName || '-') +
                (this.detail.record && this.detail.record.scope == 'DATABASE' ? ' / 库 ' + (this.detail.record.databaseName || '-') : ''));
            lines.push('健康分：' + (s.healthScore == null ? '-' : s.healthScore) +
                '  等级：' + (s.overallLevel || '-'));
            lines.push('巡检时间：' + (s.patrolTime || '-') + '  耗时：' + this.formatCost(s.costMs));
            lines.push('问题数：' + (s.problemCount == null ? 0 : s.problemCount) +
                '（警告 ' + (s.warnCount || 0) + ' / 严重 ' + (s.criticalCount || 0) + '）');
            const pushList = (title, arr) => {
                if (arr && arr.length) {
                    lines.push('');
                    lines.push(title + '：');
                    arr.forEach((it, i) => lines.push((i + 1) + '. ' + it));
                }
            };
            pushList('问题列表', s.problems);
            pushList('关键提示', s.topIssues);
            pushList('处置建议', s.suggestions);
            return lines.join('\n');
        },

        // ===== 实例配置 CRUD =====
        emptyInstForm() {
            return {
                spiId: null, instanceName: '', host: '', port: 3306, username: '', password: '',
                databases: '', enabled: 1, sort: 0, remark: '',
            };
        },
        getInstanceList() {
            getPatrolInstanceList(this.instForm).then(res => {
                this.instanceData = res.data || [];
                this.instanceTotal = res.total || 0;
            });
        },
        instPageNumberChange(p) { this.instForm.currentPage = p; this.getInstanceList(); },
        instPageSizeChange(s) { this.instForm.pageSize = s; this.instForm.currentPage = 1; this.getInstanceList(); },
        // 打开新增/编辑抽屉
        openInstanceForm(isEdit, row) {
            this.instEdit = isEdit;
            if (isEdit && row) {
                // 编辑：回填，databasesList → databases，密码置空（留空不修改）
                this.instFormData = {
                    spiId: row.spiId,
                    instanceName: row.instanceName,
                    host: row.host,
                    port: row.port || 3306,
                    username: row.username,
                    password: '',
                    databases: row.databasesList || '',
                    enabled: row.enabled == null ? 1 : row.enabled,
                    sort: row.sort == null ? 0 : row.sort,
                    remark: row.remark || '',
                };
            } else {
                this.instFormData = this.emptyInstForm();
            }
            this.instDialog = true;
            this.$nextTick(() => {
                if (this.$refs.instFormRef) this.$refs.instFormRef.clearValidate();
            });
        },
        closeInstanceForm() {
            this.instDialog = false;
            this.instEdit = false;
            this.instFormData = this.emptyInstForm();
        },
        // 测试连接：用当前表单的 host/port/username/password
        testConnection() {
            const f = this.instFormData;
            if (!f.host || !f.username || !f.password) {
                this.$message({ type: "warning", message: "请填写主机、账号、密码后再测试" });
                return;
            }
            this.testLoading = true;
            testPatrolInstance({
                host: f.host, port: f.port || 3306, username: f.username, password: f.password,
            }).then(res => {
                // 拦截器已确保 status==200 才进 then；后端 fail(500) 会走 catch
                this.$message({ type: "success", message: (res && res.data) || "连接成功" });
            }).catch(() => {
                // 错误通知已由拦截器统一弹出，这里仅结束 loading
            }).finally(() => { this.testLoading = false; });
        },
        // 提交新增/编辑
        submitInstance() {
            this.$refs.instFormRef.validate(valid => {
                if (!valid) return;
                const f = JSON.parse(JSON.stringify(this.instFormData));
                const isEdit = this.instEdit;
                this.$confirm(isEdit ? "是否确定要修改该实例?" : "是否确定要新增该实例?", "提示", {
                    confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
                }).then(() => {
                    const api = isEdit ? updatePatrolInstance : addPatrolInstance;
                    api(f).then(res => {
                        if (res.data) {
                            this.$message({ type: "success", message: isEdit ? "修改成功" : "新增成功" });
                            this.closeInstanceForm();
                            this.getInstanceList();
                        }
                    });
                }).catch(() => { this.$message({ type: "info", message: "已取消" }); });
            });
        },
        deleteInstance(row) {
            this.$confirm("是否确定要删除该实例配置, 是否继续?", "提示", {
                confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
            }).then(() => {
                deletePatrolInstance({ spiId: row.spiId }).then(res => {
                    if (res.data) {
                        this.$message({ type: "success", message: "删除成功!" });
                        this.getInstanceList();
                    }
                });
            }).catch(() => { this.$message({ type: "info", message: "已取消" }); });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.ve-table-container {
    height: auto !important;
}

/* 详情概览卡片 */
.ov-card {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 8px 12px;
    background: #fafafa;
    height: 64px;
    box-sizing: border-box;
}

.ov-label {
    font-size: 12px;
    color: #909399;
    margin-bottom: 4px;
}

.ov-value {
    font-size: 20px;
    font-weight: 600;
    color: #303133;
}

.ov-value.text {
    font-size: 13px;
    font-weight: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 摘要区块 */
.summary-block {
    border: 1px solid #d9ecff;
    background: #ecf5ff;
    border-radius: 4px;
    padding: 10px 14px;
    margin: 6px 0 14px;
}

.summary-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.summary-title {
    font-weight: 600;
    color: #303133;
    font-size: 14px;
}

.summary-sub {
    font-weight: normal;
    color: #909399;
    font-size: 12px;
    margin-left: 6px;
}

.summary-section {
    margin-top: 6px;
}

.section-label {
    font-size: 12px;
    color: #409EFF;
    font-weight: 600;
    margin-bottom: 2px;
}

.summary-list {
    margin: 0;
    padding-left: 20px;
    color: #303133;
    font-size: 13px;
    line-height: 1.7;
}

.summary-list li {
    word-break: break-all;
}

/* 检查项卡片 */
.check-item {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 10px 12px;
    margin-bottom: 8px;
    background: #fff;
}

.check-title {
    margin-bottom: 6px;
}

.metrics-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 4px;
}

.metrics-item {
    background: #f4f4f5;
    border-radius: 3px;
    padding: 2px 8px;
    font-size: 12px;
    display: inline-flex;
    align-items: center;
}

.metrics-k {
    color: #909399;
    margin-right: 4px;
}

.metrics-v {
    color: #303133;
    font-weight: 600;
}
</style>
